import { Injectable, EventEmitter } from "@angular/core";
import {
  SignalRService,
  SignalREventService,
  ISecurityQuestion,
  SecurityQuestion,
} from "./../index";

@Injectable({
  providedIn: "root", // Ensures this service is available globally through dependency injection
})
export class AuthorizationService {
  //Values stored in Authentication state
  public sections: string[] = [];
  public userName = "";
  public authKey = "";
  public fullName = "";
  public authenticated = false;
  public startPage = "";
  public userId = 0;

  public authenticateComplete: EventEmitter<boolean> =
    new EventEmitter<boolean>();
  public authenticateFailed: EventEmitter<boolean> =
    new EventEmitter<boolean>();
  public securityQeustionRetrieved: EventEmitter<ISecurityQuestion> =
    new EventEmitter<ISecurityQuestion>();

  private currentQuestion: ISecurityQuestion = null;

  private Constants = {
    AUTH_KEY: "Auth_key",
    USER_NAME: "user",
    FULL_NAME: "Full_Name",
    START_PAGE: "Start_Page",
    USER_ID: "User_ID",
    SECTIONS: "Sections",
  };
  private;

  constructor(
    private _signalRService: SignalRService,
    private _signalREventService: SignalREventService
  ) {
    if (window.localStorage.getItem("user")) {
      this.userName = window.localStorage.getItem("user");
    }

    this._signalREventService.register(
      "Authorization",
      "authorize",
      (info: any) => this.authorizeComplete(info)
    );
    this._signalREventService.register("Authorization", "authorizeFailed", () =>
      this.authorizeFailed()
    );
    this._signalREventService.register(
      "Authorization",
      "getSecurityQuestion",
      (info: any) => this.securityQuestionComplete(info)
    );
  }

  private authorizeFailed(): void {
    this.authenticateFailed.emit(false);
  }

  public getAuthorization(): string {
    if (!this.authKey) {
      const authKey = localStorage.getItem(this.Constants.AUTH_KEY);
      if (authKey) {
        this.authKey = authKey;
      }
    }
    return this.authKey;
  }

  public getUserName(): string {
    if (!this.userName) {
      const userName = localStorage.getItem(this.Constants.USER_NAME);
      if (userName) this.userName = userName;
    }
    return this.userName;
  }

  public getUserId(): number {
    if (!this.userId) {
      const userId = localStorage.getItem(this.Constants.USER_ID);
      if (userId) this.userId = parseInt(userId);
    }
    return this.userId;
  }

  /**
   * Method runs on successful authentication
   * @param info
   */
  private authorizeComplete(info: any): void {
    //auth_key is appended to headers for any auth required endpoints
    this.authKey = info.key;
    localStorage.setItem(this.Constants.AUTH_KEY, info.key);

    this.fullName = info.FullName;
    localStorage.setItem(this.Constants.FULL_NAME, this.fullName);
    this.startPage = info.StartPage;
    localStorage.setItem(this.Constants.START_PAGE, this.startPage);
    this.userId = info.id;
    localStorage.setItem(this.Constants.USER_ID, this.userId.toString());

    //TODO: create session, it's in Auth controller, need to add logic to Auth hub.

    //TODO: get session info, store

    //TODO: add session-keep alive to all modules/pages

    //TODO: on refresh - add check to see if session is still valid, if not, re-authenticate
    //TODO: This would likely still be a redirect ot the home screen since important lists would be lost, or we could add page data to local storage too

    this._signalRService
      .invoke("GetAllowedSections", this.userName)
      .then((sections: string[]) => {
        this.sections = sections;
        localStorage.setItem(this.Constants.SECTIONS, JSON.stringify(sections));
        this.authenticated = true;
        this.authenticateComplete.emit(true);
      });
  }

  private securityQuestionComplete(info: any): void {
    this.currentQuestion = new SecurityQuestion();
    this.currentQuestion.Question = info.Question;
    this.currentQuestion.SeuciryQuestionId = info.Id;
    this.securityQeustionRetrieved.emit(this.currentQuestion);
  }

  public authenticate(username: string, password: string): void {
    this.userName = username;
    window.localStorage.setItem(this.Constants.USER_NAME, this.userName);
    this._signalRService.invoke("Authenticate", this.userName, password);
  }

  public getSecurityQuestion(): void {
    this._signalRService.invoke("GetSecurityQuestion", this.userName);
  }

  public validateAnswer(answer: string): void {
    this._signalRService.invoke(
      "AnswerQuestion",
      this.currentQuestion.SeuciryQuestionId,
      answer,
      this.userName
    );
  }

  public hasPermission(area: string): boolean {
    for (const section of this.sections) {
      if (area == section) {
        return true;
      }
    }
    return false;
  }
}
